module.exports = __webpack_public_path__ + "static/futurezoneLogoC-198b200a4149250c392b5ec89ad7047a.png";